import styled from 'styled-components';
export const StyledPropertyList = styled.ul `
  width: 100%;
  padding: 0;
  margin: 0;
  list-style-type: none;
`;
//# sourceMappingURL=property-list.styles.js.map